import React from 'react';
import type { Logger } from '@feature-hub/core';

type LoggerState = {
  logger: Logger;
};

export type State = {
  logger: Logger;
};

export const defaultState: LoggerState = {
  logger: console,
};

export const loggerStateContext = React.createContext<State | null>(null);

const Provider = ({ children, logger }: { children: React.ReactNode; logger?: Logger }) => {
  const [state] = React.useState({
    ...defaultState,
    logger: logger || console,
  });

  return <loggerStateContext.Provider value={state}>{children}</loggerStateContext.Provider>;
};

function useLoggerState() {
  const context = React.useContext(loggerStateContext);
  if (!context) {
    throw new Error('loggerState must be used within a Provider');
  }
  return context;
}

export default { Provider, useLoggerState };
